import i18n from 'i18next'

function formatNumber(number: number): string {
  const locale = i18n.language

  return new Intl.NumberFormat(locale).format(number)
}

export { formatNumber }
